import { Checkbox, FormControlLabel, ListItemText, MenuItem, Popover, Select, useTheme } from '@material-ui/core';
import React, { useState } from 'react';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { AgeRangeCont, CustomInputAdornment } from './OpportunitiesFilter.styles';
import { SelectArrowDownIcon } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
import { useContextSelector } from 'use-context-selector';
import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';

interface Props {
  anchorEl: null | HTMLElement;
  handleClose: () => void;
  open: boolean;
}

const AgePopOver: React.FC<Props> = ({ anchorEl, handleClose, open }) => {
  const isDark = useTheme().palette.type === 'dark';
  const [ageRangeFrom, setAgeRangeFrom] = useState<number[]>(Array.from(Array(110).keys()).map((i) => i));
  const [ageRangeTo, setAgeRangeTo] = useState<number[]>(Array.from(Array(110).keys()).map((i) => i + 1));

  const age_range_from = useContextSelector(OpportunitiesContext, (state) => state.filters.age_range_from);
  const age_range_to = useContextSelector(OpportunitiesContext, (state) => state.filters.age_range_to);
  const age_range_type = useContextSelector(OpportunitiesContext, (state) => state.filters.age_range_type);
  const setFilters = useContextSelector(OpportunitiesContext, (state) => state.setFilters);

  const handleChange = (event: any) => {
    const {
      target: { value, name },
    } = event;
    if (name === 'age_range_from' || name === 'age_range_to') {
      return setFilters({
        [name]: value,
        //   [name]: name === 'sort' ? sortingFilters.find((s) => s.value === value)?.key : value,
      });
    }

    if (name === 'age_range_type') {
      if (value === 'Month') {
        setAgeRangeFrom(Array.from(Array(23).keys()).map((i) => i));
        setAgeRangeTo(Array.from(Array(24).keys()).map((i) => i + 1));
        return setFilters({
          age_range_from: 0,
          age_range_to: 24,
          age_range_type: value,
          //   [name]: name === 'sort' ? sortingFilters.find((s) => s.value === value)?.key : value,
        });
      } else {
        setAgeRangeFrom(Array.from(Array(109).keys()).map((i) => i));
        setAgeRangeTo(Array.from(Array(110).keys()).map((i) => i + 1));
        return setFilters({
          age_range_from: 0,
          age_range_to: 110,
          age_range_type: value,
          //   [name]: name === 'sort' ? sortingFilters.find((s) => s.value === value)?.key : value,
        });
      }
    }
  };

  return (
    <Popover
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={open}
    >
      <AgeRangeCont>
        <div style={{ display: 'flex', gap: 20, justifyContent: 'space-between', width: '100%' }}>
          <CustomTypography style={{ marginBottom: 10 }}>Playable age range:</CustomTypography>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <Select
            style={{ height: 40, minWidth: 120 }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  minWidth: 200,
                },
              },
              //   MenuListProps: { className: selectCls },
            }}
            IconComponent={() => (
              <SelectArrowDownIcon
                style={{ position: 'absolute', right: 0, top: 17, pointerEvents: 'none' }}
                htmlColor={isDark ? COLORS.WHITE : COLORS.BLACK}
              />
            )}
            variant="outlined"
            fullWidth
            value={age_range_from}
            onChange={handleChange}
            startAdornment={<CustomInputAdornment position="start">From:</CustomInputAdornment>}
            renderValue={(val: any) => <CustomTypography style={{ color: COLORS.PRIMARY }}>{val}</CustomTypography>}
            name="age_range_from"
          >
            {ageRangeFrom.map((item) => (
              <MenuItem key={item} value={item} disabled={item >= age_range_to}>
                <ListItemText primary={item} style={{ textTransform: 'capitalize' }} />
              </MenuItem>
            ))}
          </Select>
          <Select
            style={{ height: 40, minWidth: 120 }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  minWidth: 200,
                },
              },
              //   MenuListProps: { className: selectCls },
            }}
            IconComponent={() => (
              <SelectArrowDownIcon
                style={{ position: 'absolute', right: 0, top: 17, pointerEvents: 'none' }}
                htmlColor={isDark ? COLORS.WHITE : COLORS.BLACK}
              />
            )}
            variant="outlined"
            fullWidth
            value={age_range_to}
            onChange={handleChange}
            startAdornment={<CustomInputAdornment position="start">To:</CustomInputAdornment>}
            renderValue={(val: any) => <CustomTypography style={{ color: COLORS.PRIMARY }}>{val}</CustomTypography>}
            name="age_range_to"
          >
            {ageRangeTo.map((item) => (
              <MenuItem key={item} value={item} disabled={item <= age_range_from}>
                <ListItemText primary={item} style={{ textTransform: 'capitalize' }} />
              </MenuItem>
            ))}
          </Select>
        </div>
        <FormControlLabel
          label="Switch to months"
          control={
            <Checkbox
              value={age_range_type === 'Month' ? 'Year' : 'Month'}
              checked={age_range_type === 'Month'}
              onChange={handleChange}
              color="primary"
              name="age_range_type"
            />
          }
        />
      </AgeRangeCont>
    </Popover>
  );
};

export default AgePopOver;
